/* Decants Australia — homepage behaviour (da-*). Loaded once as a module; safe to include from every da- section. */
if (!window.__daHome) {
  window.__daHome = true;
  document.documentElement.classList.add('da-js');

  const ease = (fn) => { try { fn(); } catch (e) { console.warn('[da-home]', e); } };

  /* ---------- reveals ---------- */
  const setupReveals = () => {
    const els = document.querySelectorAll('.da-rv, .da-stagger');
    if (!('IntersectionObserver' in window)) { els.forEach((el) => el.classList.add('da-in')); return; }
    const io = new IntersectionObserver((entries) => {
      entries.forEach((e) => { if (e.isIntersecting) { e.target.classList.add('da-in'); io.unobserve(e.target); } });
    }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });
    els.forEach((el) => { if (!el.dataset.daObserved) { el.dataset.daObserved = '1'; io.observe(el); } });
  };

  /* ---------- marquees: duplicate track once for a seamless loop ---------- */
  const setupMarquees = () => {
    document.querySelectorAll('[data-da-marquee]').forEach((t) => {
      if (t.dataset.daDuped) return;
      t.dataset.daDuped = '1';
      t.innerHTML += t.innerHTML;
    });
  };

  /* ---------- hero parallax + mobile dock ---------- */
  const setupScroll = () => {
    const hero = document.querySelector('.da-hero');
    const heroImg = document.querySelector('[data-da-hero-img]');
    const dock = document.querySelector('.da-dock');
    // Horizon scrolls inside .page-wrapper (html/body are overflow:hidden) — fall back to window elsewhere.
    const wrap = document.querySelector('.page-wrapper');
    const scroller = wrap && wrap.scrollHeight > wrap.clientHeight + 10 ? wrap : window;
    const getY = () => (scroller === window ? window.scrollY : scroller.scrollTop);
    const onScroll = () => {
      const y = getY();
      if (heroImg && y < window.innerHeight * 1.2) heroImg.style.transform = `translateY(${-y * 0.12}px)`;
      if (dock) dock.classList.toggle('da-show', y > (hero ? hero.offsetHeight * 0.7 : 600));
    };
    scroller.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  };

  /* ---------- FAQ: one open at a time ---------- */
  const setupFaq = () => {
    document.querySelectorAll('.da-acc details').forEach((d) => {
      d.addEventListener('toggle', () => {
        if (d.open) d.closest('.da-acc').querySelectorAll('details').forEach((o) => { if (o !== d) o.open = false; });
      });
    });
  };

  /* ---------- size toggle on best sellers ---------- */
  const readVariants = (card) => {
    try { return JSON.parse(card.querySelector('.da-vars')?.textContent || '[]'); } catch (e) { return []; }
  };
  const pickVariant = (variants, size) => {
    const s = (size || '').toLowerCase().replace(/\s+/g, '');
    return variants.find((v) => (v.t || '').toLowerCase().replace(/\s+/g, '') === s)
      || variants.find((v) => (v.t || '').toLowerCase().replace(/\s+/g, '').includes(s))
      || null;
  };
  const applySize = (section, size) => {
    section.querySelectorAll('.da-card').forEach((card) => {
      const variants = readVariants(card);
      if (!variants.length) return;
      const v = variants.length === 1 && !pickVariant(variants, size) ? variants[0] : pickVariant(variants, size);
      const priceEl = card.querySelector('.da-card__price');
      const quick = card.querySelector('.da-quick');
      const link = card.querySelector('a.da-card__ph');
      if (!v) {
        if (priceEl) { priceEl.style.opacity = 0; setTimeout(() => { priceEl.innerHTML = `<small>${size}</small>—`; priceEl.style.opacity = 1; }, 160); }
        if (quick) { quick.textContent = `Not in ${size}`; quick.disabled = true; quick.dataset.variantId = ''; }
        return;
      }
      const label = variants.length === 1 ? '' : `<small>${v.t}</small>`;
      if (priceEl) { priceEl.style.opacity = 0; setTimeout(() => { priceEl.innerHTML = `${label}${v.pf}`; priceEl.style.opacity = 1; }, 160); }
      if (quick) {
        quick.dataset.variantId = v.id;
        quick.disabled = !v.a;
        quick.textContent = v.a ? (variants.length === 1 ? quick.dataset.labelAdd : `${quick.dataset.labelAdd} · ${v.t}`) : quick.dataset.labelSoldOut;
      }
      if (link && variants.length > 1) link.href = link.href.split('?')[0] + '?variant=' + v.id;
    });
  };
  const setupSizeToggles = () => {
    document.querySelectorAll('.da-shop').forEach((section) => {
      const seg = section.querySelector('.da-seg');
      if (!seg) return;
      const initial = seg.querySelector('button[aria-pressed="true"]') || seg.querySelector('button');
      if (initial) applySize(section, initial.dataset.size);
      seg.addEventListener('click', (e) => {
        const b = e.target.closest('button'); if (!b) return;
        seg.querySelectorAll('button').forEach((x) => x.setAttribute('aria-pressed', x === b ? 'true' : 'false'));
        applySize(section, b.dataset.size);
      });
    });
  };

  /* ---------- quick add (Horizon-compatible: fires CartLinesUpdateEvent so the drawer + bubble update) ---------- */
  let toastEl;
  const toast = (html) => {
    if (!toastEl) { toastEl = document.createElement('div'); toastEl.className = 'da-toast'; document.body.appendChild(toastEl); }
    toastEl.innerHTML = html; toastEl.classList.add('da-show');
    clearTimeout(toastEl._t); toastEl._t = setTimeout(() => toastEl.classList.remove('da-show'), 3200);
  };
  const cartSectionIds = () => [...document.querySelectorAll('cart-items-component')].map((el) => el.dataset.sectionId).filter(Boolean);
  const routes = () => (window.Theme && window.Theme.routes) || { cart_add_url: '/cart/add', cart_url: '/cart' };

  const addToCart = async (variantId, holder) => {
    if (!variantId) return;
    holder.classList.add('da-busy');
    let events = null;
    try { events = await import('@shopify/events'); } catch (e) { events = null; }
    const deferred = events?.CartLinesUpdateEvent?.createPromise ? events.CartLinesUpdateEvent.createPromise() : null;
    if (events?.CartLinesUpdateEvent && deferred) {
      holder.dispatchEvent(new events.CartLinesUpdateEvent({
        action: 'add', context: 'product',
        lines: [{ merchandiseId: String(variantId), quantity: 1 }],
        promise: deferred.promise,
      }));
    }
    try {
      const addUrl = String(routes().cart_add_url || '/cart/add').replace(/\.js$/, '') + '.js';
      const res = await fetch(addUrl, {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }], sections: cartSectionIds().join(',') }),
      });
      const data = await res.json();
      if (data.status) throw new Error(data.description || data.message || 'Could not add to cart');
      const cart = await fetch('/cart.js', { headers: { Accept: 'application/json' } }).then((r) => r.json());
      if (deferred) {
        deferred.resolve({
          cart: events.CartLinesUpdateEvent.createCartFromAjaxResponse ? events.CartLinesUpdateEvent.createCartFromAjaxResponse(cart) : cart,
          detail: { items: cart.items, source: 'product-form-component', sourceId: 'da-quick-add', itemCount: 1, productId: holder.dataset.productId, sections: data.sections, didError: false },
        });
      }
      holder.classList.add('da-added');
      setTimeout(() => holder.classList.remove('da-added'), 2200);
      toast(`Added to cart · <a href="${routes().cart_url || '/cart'}">View cart</a>`);
    } catch (err) {
      if (deferred) deferred.reject(err);
      toast(err.message || 'Could not add to cart');
    } finally {
      holder.classList.remove('da-busy');
    }
  };

  const setupQuickAdd = () => {
    document.addEventListener('click', (e) => {
      const btn = e.target.closest('[data-da-add]');
      if (!btn) return;
      e.preventDefault();
      const holder = btn.closest('.da-card, .da-set') || btn;
      addToCart(btn.dataset.variantId, holder);
    });
  };

  const init = () => { ease(setupMarquees); ease(setupReveals); ease(setupScroll); ease(setupFaq); ease(setupSizeToggles); ease(setupQuickAdd); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', () => { ease(setupMarquees); ease(setupReveals); ease(setupSizeToggles); });
}